<template>
  <div class="container">
    <div class="row d-flex justify-content-center">
      <ul class="timeline">
        <li class="active">Customize</li>
        <li>Checkout</li>
        <li>Publish</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Timeline', 
  props: ['option']
}
</script>

<style lang="scss" scoped>
.timeline {
  margin: 0px;
  padding: 0px;
  text-align: center;
}
.timeline li{
  display: inline;
  text-align: center;
  margin: 8px 12px;
  color:#999;
  &.active {
    color:#333;
  }
  &::after {
    content: '→';
    left: 6px;
    margin-left: 12px;
    margin-right: -12px;
    width: auto;
    display: inline-block;
  }
  &:last-child::after {
    content: '';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue